import * as React from "react"
import styled from "styled-components"

const IMG_FORK =
  "https://webimages.mongodb.com/_com_assets/cms/kyynxydp13g3j3g80-fork.svg?auto=format%252Ccompress"

const IMG_STAR =
  "https://webimages.mongodb.com/_com_assets/cms/kyynz2jy9xz5vd4ez-star.svg?auto=format%252Ccompress"

const StyledAnchor = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.3em;
  font-weight: bold;
  font-size: 0.8em;

  > span {
    color: black;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    background: #f9f9ff;
    border: 2px solid #d5d4f9;
    border-radius: 15px;
    margin: 0;
    padding: 1px 0.5em;
    color: #6e60f9;
    font-weight: bold;
    background: transparent;
  }
`

const GithubButton = ({
  type,
  data,
  url = "https://github.com/realm",
}) => {
  return (
    <StyledAnchor href={url}>
      <img src={type === "fork" ? IMG_FORK : IMG_STAR} alt={type} />
      <span>{type === "fork" ? "Fork" : "Star"}</span>
      <div>{type === "fork" ? data.forks : data.stars}</div>
    </StyledAnchor>
  )
}

export default GithubButton
